function IsEmail(email){

    if(email === undefined) return false
    const mailformat = RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g);
    return email.match(mailformat);
}

export default IsEmail